import {
  ChangeDetectorRef,
  Component,
  Inject,
  inject,
  OnInit,
} from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { LayoutComponent } from '../../core/layout/layout.component';
import { MatInputModule } from '@angular/material/input';
import { MatTabsModule } from '@angular/material/tabs';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ActivatedRoute, Router } from '@angular/router';
import { QuotationService } from '../../features/quotation/services/quotation.service';
import { ToastrService } from 'ngx-toastr';
import { ConfirmDialog } from '../../shared/components/confirm-dialog/confirm-dialog';
// import { PaymentsItemService } from '../../features/payments/services/payments.service';
import { QUOTESTATUS } from '../../helpers/helper-file';
import { debounceTime, distinctUntilChanged, Subject } from 'rxjs';
import { ModuleIds } from '../../shared/permission-constants/permission-const';
import { PermissionService } from '../../shared/services/permission.service';
// import { PermissionDirective } from '../../shared/directives/permissions.directive';
// import { Permission } from '../../shared/services/permissions';

@Component({
  selector: 'app-quotation-details',
  standalone: true,
  imports: [
    CommonModule,
    LayoutComponent,
    MatInputModule,
    MatTabsModule,
    MatMenuModule,
    MatIconModule,
    MatSelectModule,
    FormsModule,
    ReactiveFormsModule,
    // PermissionDirective,
  ],
  templateUrl: './quotation-details.component.html',
  styleUrl: './quotation-details.component.scss',
})
export class QuotationDetailsComponent implements OnInit {
  selectedTabIndex = 0;
  readonly dialog = inject(MatDialog);
  isDropdownOpen = false;
  expenseDetails: any = {};
  detailsLoading: any = false;
  loading: boolean = false;
  pdfLoading: boolean = false;
  allQuotes: any = [];
  quoteData: any = {};
  parentQuoteId: any;
  parentQuoteData: any = {};
  parentQuoteStatus: string;
  primaryQuoteCode: any = {};
  allParentQuotes: any[] = [];
  customerId: any;
  selectedParentQuote: any;
  selectedQuote: any = {};
  private searchSubject = new Subject<string>();
  // Permission = Permission;
  isAttacheFile = false;

  isCommentsOpen = false;
  commentsList: any;
  commentsForm: FormGroup;
  quoteDropdown: any;
  matchedQuote: any;
  canCreateQuotation$ = this.permissionService.hasPermission(
    ModuleIds.Quotation,
    'Create'
  );
canEditQuotation$ = this.permissionService.hasPermission(
    ModuleIds.Quotation,
    'Edit'
  );
  canDeleteQuotation$ = this.permissionService.hasPermission(
    ModuleIds.Quotation,
    'Delete'
  );
  canReviseQuotation$ = this.permissionService.hasPermission(
    ModuleIds.Quotation,
    'Revision'
  );

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private toastr: ToastrService,
    private quoteService: QuotationService,
    // private commentService: PaymentsItemService,
    private fb: FormBuilder,
    private cdr: ChangeDetectorRef,
    private permissionService: PermissionService
  ) {}

  ngOnInit(): void {
    this.fetchAllParentQuotes();
    this.route.queryParamMap.subscribe((queryParams) => {
      this.parentQuoteId = queryParams.get('id');

      if (this.parentQuoteId) {
        const id = +this.parentQuoteId;
        this.fetchQuoteById(id);
      }
    });

    if (this.selectedQuote?.quoteItems) {
      this.selectedQuote.quoteItems = this.selectedQuote.quoteItems.map(
        (item: any) => ({
          ...item,
          grossAmount: item.quantity * item.rate || 0,
          netAmount: (item.quantity * item.rate || 0) - (item.discount || 0),
        })
      );
    }

    // Initialize search functionality
    this.searchSubject
      .pipe(debounceTime(600), distinctUntilChanged())
      .subscribe((searchTerm) => {
        this.fetchAllParentQuotes(searchTerm);
      });

    // Initialize the comments form
    this.commentsForm = this.fb.group({
      comments: ['', Validators.required],
    });
  }

  onSearch(event: Event) {
    const input = event.target as HTMLInputElement;
    const searchTerm = input.value;
    this.searchSubject.next(searchTerm);
  }

  fetchAllParentQuotes(search: string = ''): void {
    this.loading = true;

    this.quoteService.fetchQuotations(search).subscribe({
      next: (parentQuotes) => {
        this.allParentQuotes = parentQuotes;

        if (this.parentQuoteId) {
          const targetId = +this.parentQuoteId;
          this.selectedTabIndex = this.allParentQuotes.findIndex(
            (quote: any) => quote.id === targetId
          );
          if (this.selectedTabIndex === -1) {
            this.selectedTabIndex = 0;
          }
        } else {
          this.selectedTabIndex = 0;
        }

        this.parentQuoteData = this.allParentQuotes[this.selectedTabIndex] || {};
        this.parentQuoteStatus = this.parentQuoteData.quoteStatus;

        // this.initializeSelectedQuote();
      },
      error: (err) => {
        console.error('Error fetching all parent quotes:', err);
      },
      complete: () => {
        this.loading = false;
      },
    });
  }

  fetchQuoteById(id: any){
    this.quoteService.fetchQuoteById(Number(id)).subscribe({
      next: (data) => {
        this.customerId = data.customerId;
        this.parentQuoteData = data?.quote;
        this.quoteDropdown = data?.relatedQuotes;
        console.log('parentQuoteData',this.parentQuoteData);
        
        this.primaryQuoteCode = this.parentQuoteData?.quoteCode;
        this.parentQuoteStatus = this.parentQuoteData?.quoteStatus;

        // if (data?.quoteData && data.quoteData.length > 0) {
          const matchedQuote = this.quoteDropdown.find((q: any) => q.id === data?.quote?.id);
          this.matchedQuote = matchedQuote || null;  // fallback to null if not found
          this.selectedQuote = data?.quote;
    
        //     ) || data.quoteData[0];
        // } else {
        //   this.router.navigate(['/quotation']);
        // }
      },
      error: (err) => {
        console.error('Error fetching quote by ID:', err);
      },
    });
  }

  hasFinalQuote(): boolean {
    return this.parentQuoteData?.quoteData?.some((q: any) => {
      console.log('q?.quoteType',q?.quoteType);
      
      return q?.quoteType === 'Final'
    });
  }

  closeQuotation() {
    const parentQuoteId = +this.selectedQuote?.parentQuoteId;
    const status = 'Closed';
    this.quoteService.updateParentQuoteStatus(parentQuoteId, status).subscribe({
      next: (response) => {
        this.toastr.success('Quotation closed.');
        this.fetchAllParentQuotes();
      },
      error: (error) => {
        this.toastr.error(error.message || 'Failed to close quotation');
      },
    });
  }

  finalizeQuotation() {
    console.log('this.parentQuoteData', this.parentQuoteData);

    const parentQuoteCode = this.parentQuoteData?.quoteCode;
    // this.router.navigate([`quotation/quotation-edit/${this.parentQuoteData?.id}`]);
    this.parentQuoteData?.quoteData.map((quote: any) => {
      if (quote?.quoteCode === parentQuoteCode) {
        const quoteId = quote?.id;
        const quoteItem: any = [];
        const quoteExclusionItem: any = [];
        const quoteAttachmentItem: any = [];
        this.quoteService
          .finalizeQuote(
            quoteId,
            quoteItem,
            quoteExclusionItem,
            quoteAttachmentItem
          )
          .subscribe({
            next: (response) => {
              this.toastr.success('Quotation finalized.');
              this.fetchAllParentQuotes();
              console.log('response', response);
              const finalizeQuoteId = response?.data?.finalizeQuote?.id;
              if (finalizeQuoteId) {
                this.router.navigate(
                  [`quotation/quotation-edit/${finalizeQuoteId}`],
                  {
                    queryParams: { finalizeQuote: true },
                  }
                );
              } else {
                this.toastr.error('Failed to get the finalized quote ID.');
              }
            },
            error: (error) => {
              this.toastr.error(
                error.message || 'Failed to finalize quotation'
              );
            },
          });
      }
    });
  }

  confirmSent(){
    const dialogRef = this.dialog.open(ConfirmDialog, {
      data: {
        title: 'Confirm sent quotation?',
        message: 'Are you sure you want to sent this quotation?',
        confirmText: 'Sent Quotation',
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result === true) {
        this.quoteMarkAsSent();
      }
    });
  }

  quoteMarkAsSent() {
    const quoteId = +this.selectedQuote?.id;

    this.quoteService
      .markAsSentQuote(quoteId)
      .subscribe({
        next: (response) => {
          this.toastr.success('Quotation marked as sent');
          this.fetchAllParentQuotes();
          this.fetchQuoteById(quoteId);
        },
        error: (error) => {
          this.toastr.error('Failed to sent quotation');
        },
      });
  }

  confirmReject(){
    const dialogRef = this.dialog.open(ConfirmDialog, {
      data: {
        title: 'Confirm reject quotation?',
        message: 'Are you sure you want to reject this quotation?',
        confirmText: 'Reject Quotation',
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result === true) {
        this.rejectQuote();
      }
    });
  }

  rejectQuote() {
    const quoteId = +this.selectedQuote?.id;

    this.quoteService
      .rejectQuote(quoteId)
      .subscribe({
        next: (response) => {
          this.toastr.success('Quotation rejected');
          this.fetchAllParentQuotes();
          this.fetchQuoteById(quoteId);
        },
        error: (error) => {
          this.toastr.error('Failed to reject quotation');
        },
      });
  }

  quoteRevision(): void {
    if (!this.selectedQuote?.id) {
      this.toastr.warning('Please select a valid parent quote and quote.');
      return;
    }

    this.loading = true;
    this.quoteService
      .revisionQuote(this.selectedQuote.id)
      .subscribe({

        next: (response) => {
          console.log('response',response)
          this.loading = false;
          this.toastr.success('Quote revised successfully.');
          const revisedQuoteId = response?.data?.reviseQuote?.id;
          if (revisedQuoteId) {
            this.router.navigate(
              [`quotation/quotation-edit/${revisedQuoteId}`],
              {
                queryParams: { revisionQuote: true },
              }
            );
          } else {
            this.toastr.error('Failed to get the revised quote ID.');
          }
        },
        error: (err) => {
          this.loading = false;
          console.error('Error revising quote:', err);
          this.toastr.error(err);
        },
      });
  }

  confirmCancel(id: any) {
    const dialogRef = this.dialog.open(ConfirmDialog, {
      data: {
        title: 'Confirm cancel variation?',
        message: 'Are you sure you want to cancel this variation?',
        confirmText: 'Cancel Variation',
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result === true) {
        this.cancelVariation(Number(id));
      }
    });
  }

  cancelVariation(id: number) {
    if (id) {
      this.quoteService.cancelVariationQuote(Number(id)).subscribe({
        next: (data) => {
          this.toastr.success(
            'Variation quote cancelled successfully',
            'Success'
          );
        },
        error: (error) => {
          this.toastr.error(error?.message, 'Error');
        },
      });
    }
  }

  quoteVariation(): void {
    if (!this.selectedQuote?.id) {
      this.toastr.warning('Please select a valid parent quote and quote.');
      return;
    }

    this.loading = true;
    const parentId = +this.parentQuoteId;
    this.quoteService
      .reviseQuoteVariation(
        this.selectedQuote?.parentQuoteId,
        this.selectedQuote.id
      )
      .subscribe({
        next: (response) => {
          this.loading = false;
          this.toastr.success('Variation created successfully.');
          const variatedQuoteId = response?.data?.reviseQuoteVariation?.id;
          if (variatedQuoteId) {
            this.router.navigate(
              [`quotation/quotation-edit/${variatedQuoteId}`],
              {
                queryParams: { variationQuote: true },
              }
            );
            // this.router.navigate([`quotation/quotation-edit/${variatedQuoteId}`], { queryParams: { type: 'variation' } });
          } else {
            this.toastr.error('Failed to get the revised quote ID.');
          }
        },
        error: (err) => {
          this.loading = false;
          console.error('Error revising quote:', err);
          this.toastr.error(err);
        },
      });
  }

  selectTab(index: number): void {
    this.selectedTabIndex = index;
    this.parentQuoteData = this.allParentQuotes[index];
    this.parentQuoteStatus = this.parentQuoteData.parentQuoteStatus;

    // Select the first quote in the selected tab
    if (
      Array.isArray(this.parentQuoteData?.quoteData) &&
      this.parentQuoteData?.quoteData?.length > 0
    ) {
      this.selectedQuote = this.parentQuoteData?.quoteData[0];
    } else {
      this.selectedQuote = null;
    }

    if (this.parentQuoteData) {
      this.router.navigate(['quotation/quotation-details'], {
        queryParams: { id: this.parentQuoteData.id },
      });
    }
  }

  private initializeSelectedQuote(): void {
    if (
      this.parentQuoteData 
    ) {
      console.log('this.parentQuoteData',this.parentQuoteData);
      
      this.selectedQuote = this.parentQuoteData;
    }
  }

  onQuoteSelectionChange(selectedQuote: any): void {
    console.log('selectedQuote',selectedQuote);
    
    if(selectedQuote){
      
      this.selectedQuote = this.parentQuoteData; // ensure it's the same reference
      this.fetchQuoteById(selectedQuote?.id);

      
    }
    
  }

  getTotalDiscount(): number {
    return (
      this.selectedQuote?.quoteItems?.reduce(
        (total: any, item: any) => total + (item.discount || 0),
        0
      ) || 0
    );
  }

  onDeleteQuoteById(quoteId: number): void {
    const dialogRef = this.dialog.open(ConfirmDialog);

    dialogRef.afterClosed().subscribe((result) => {
      if (result === true) {
        this.removeQuoteById(quoteId);
      }
    });
  }

  private removeQuoteById(quoteId: number): void {
    this.quoteService.removeQuote(quoteId).subscribe({
      next: () => {
        this.toastr.success('Quotation removed successfully.');
        this.fetchAllParentQuotes();
      },
      error: (error) => {
        console.log('quote remove error', error);
        this.toastr.error(
          error.message || 'Failed to remove quotation. Please try again.'
        );
      },
    });
  }

  openDialog() {
    const dialogRef = this.dialog.open(UploadQuotationDetailsDialog);
  }

  openQuotaionDialog() {
    const dialogQuotaionRef = this.dialog.open(QuotaionRejectDialog);
  }

  openQuotaionApprovalDialog() {
    if (!this.selectedQuote?.id) {
      this.toastr.warning('Please select a quote to approve.');
      return;
    }

    const dialogQuotaionRef = this.dialog.open(QuotaionApproveDialog, {
      // data: { quoteId: this.selectedQuote.id },
      data: {
        quoteId: this.selectedQuote.id,
      },
    });

    dialogQuotaionRef.afterClosed().subscribe((result) => {
      if (result) {
        this.fetchAllParentQuotes();
        this.fetchQuoteById(result);
        // this.toastr.success('Approval confirmed.');
      }
    });
  }



  acceptQuotation() {
    if (!this.selectedQuote?.id) {
      this.toastr.warning('Please select a quote to approve.');
      return;
    }

    const dialogRef = this.dialog.open(ConfirmDialog,
      {
        data: {
          title: 'Accept Quotation',
          message: 'Are you sure you want to accept this quotation?',     
          confirmText: 'Accept'
        }
      }
    );
    dialogRef.afterClosed().subscribe((result) => {
      if (result === true) {

    this.quoteService.acceptQuote(this.selectedQuote.id).subscribe({
      next: (response) => {
        this.toastr.success('Quotation accepted successfully.');
        this.fetchAllParentQuotes();
        this.fetchQuoteById(this.selectedQuote.id);
      },
      error: (err) => {
        this.loading = false;
        console.error('Error revising quote:', err);
        this.toastr.error(err);
      },
    })
  }
    });
  }

  toggleDropdown(event?: MouseEvent) {
    if (event) {
      event.stopPropagation();
    }
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  toggleComments(event?: MouseEvent) {
    if (event) {
      event.stopPropagation();
    }
    const selectedItem = this.allParentQuotes[this.selectedTabIndex];
    const itemId = selectedItem.id;
    this.fetchComments(itemId);
    this.isCommentsOpen = !this.isCommentsOpen;
  }

  fetchComments(refId: number) {
    const loginEmployee: any = localStorage.getItem('loggedInUser');
    const employee = JSON.parse(loginEmployee);
    const employeeId = employee.employeeId;

    const value = {
      employeeId: employeeId,
      refId: refId,
      activityType: 'Comment',
      type: 'Quote',
    };
    this.loading = true;
    // this.commentService.comments(value).subscribe({
    //   next: (items) => {
    //     this.commentsList = items;
    //     this.loading = false;
    //   },
    //   error: (err) => {
    //     console.error('Error fetching all comments:', err);
    //     this.loading = false;
    //   },
    // });
  }

  onCommentSubmit(): void {
    if (this.commentsForm.invalid || !this.commentsForm.value.comments.trim()) {
      this.commentsForm.markAllAsTouched();
      this.toastr.warning('Please enter a comment before submitting.');
      return;
    }

    const loginEmployee: any = localStorage.getItem('loggedInUser');
    const employee = JSON.parse(loginEmployee);
    const employeeId = employee.employeeId;
    const selectedIteam = this.allParentQuotes[this.selectedTabIndex];
    const refId = selectedIteam.id;

    const data = this.commentsForm.value;

    const createCommentInput = {
      employeeId: employeeId,
      refId: refId,
      type: 'Quote',
      activityType: 'Comment',
      note: data?.comments,
    };

    this.loading = true;
    // this.commentService.createComment(createCommentInput).subscribe({
    //   next: () => {
    //     this.loading = false;
    //     const selectedIteam = this.allParentQuotes[this.selectedTabIndex];
    //     const itemId = selectedIteam.id;
    //     this.fetchComments(itemId);
    //     this.toastr.success('Comments added');
    //     this.commentsForm.reset();
    //   },
    //   error: (error) => {
    //     this.loading = false;
    //     this.toastr.error(error.message || 'Failed to add comments.');
    //   },
    // });
  }

  toggleAttachFile(event?: MouseEvent) {
    if (event) {
      event.stopPropagation();
    }
    this.isAttacheFile = !this.isAttacheFile;
  }

  viewAttachments(url: any) {
    const token = localStorage.getItem('AUTH_TOKEN');
    fetch(url, {
      method: 'GET',
      headers: {
        authorization: token ? `Bearer ${token}` : '',
      },
    })
      .then((response) => response.blob())
      .then((blob) => {
        const url = URL.createObjectURL(blob);
        window.open(url, '_blank');
      })
      .catch((error) => console.error('Error:', error));
  }

  onRemoveDocument(id: any) {
    if (id) {
      const dialogRef = this.dialog.open(ConfirmDialog);
      dialogRef.afterClosed().subscribe((result) => {
        if (result === true) {
          this.quoteService.removeQuoteAttachmentById(Number(id)).subscribe({
            next: (data) => {
              if (data) {
                this.toastr.success(
                  'Attachment removed successfully',
                  'Success'
                );

                this.quoteService
                  .fetchParentQuoteById(+this.parentQuoteId)
                  .subscribe({
                    next: (data) => {
                      this.customerId = data.partnerData.id;
                      this.parentQuoteData = data;
                      this.selectedQuote = this.parentQuoteData?.quoteData[0];
                      if (!data?.quoteData || data.quoteData.length === 0) {
                        this.router.navigate(['/quotation']);
                      }
                    },
                    error: (err) => {
                      console.error('Error fetching parent quote by ID:', err);
                    },
                  });
              }
            },
            error: (error) => this.toastr.error(error, 'Error'),
          });
        }
      });
    }
  }

  onViewDocument() {
    const url = this.selectedQuote.quoteUrl;
    this.pdfLoading = true;
    if (url) {
      const token = localStorage.getItem('AUTH_TOKEN');
      fetch(url, {
        method: 'GET',
        headers: {
          authorization: token ? `Bearer ${token}` : '',
        },
      })
        .then((response: any) => response.blob())
        .then((blob: any) => {
          this.pdfLoading = false;
          const url = URL.createObjectURL(blob);
          window.open(url, '_blank');
        })
        .catch((error: any) => {
          console.error('Error:', error);
        });
    } 
    // else {
    //   this.quoteService.generateQuotePDF(this.selectedQuote?.id).subscribe({
    //     next: (pdfResponse) => {
    //       this.pdfLoading = false;
    //       const pdfUrl = pdfResponse.data.getQuotePDF.url;
    //       const token = localStorage.getItem('AUTH_TOKEN');
    //       fetch(pdfUrl, {
    //         method: 'GET',
    //         headers: {
    //           authorization: token ? `Bearer ${token}` : '',
    //         },
    //       })
    //         .then((response: any) => response.blob())
    //         .then((blob: any) => {
    //           const url = URL.createObjectURL(blob);
    //           window.open(url, '_blank');
    //         })
    //         .catch((error: any) => {
    //           console.error('Error:', error);
    //         });
    //     },
    //     error: (pdfError) => {
    //       console.error('Error generating PDF:', pdfError);
    //       this.toastr.error(pdfError.message || 'Failed to generate PDF.');
    //     },
    //   });
    // }
  }

  navigateTo(route: string) {
    this.router.navigate([route]);
  }

  navigateToSendMail(id: number) {
    const quoteId = +id;
    // this.router.navigate([`quotation/send-mail/${quoteId}`]);
    this.router.navigate([`quotation/quotation-details/mail`], {
      queryParams: { quoteId },
    });
  }

  navigateToEdit(quoteId: string): void {
    if (quoteId) {
      this.router.navigate([`quotation/quotation-edit/${quoteId}`]);
    } else {
      console.error('No quote ID selected');
    }
  }
}

@Component({
  selector: 'upload-quotation-details-dialog',
  templateUrl: 'upload-quotation-details-dialog.html',
  styleUrls: ['./quotation-details.component.scss'],
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule],
})
export class UploadQuotationDetailsDialog {
  file: any = null;

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      this.file = file;
    }
  }
}

@Component({
  selector: 'quotaion-reject-dialog',
  templateUrl: 'quotation-reject-dialog.html',
  styleUrls: ['./quotation-details.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
  ],
})
export class QuotaionRejectDialog {}

@Component({
  selector: 'quotaion-approve-dialog',
  templateUrl: 'quotation-approval-dialog.html',
  styleUrls: ['./quotation-details.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
  ],
})
export class QuotaionApproveDialog implements OnInit {
  quoteId: number;
  projectId: number;
  dlp: boolean = false;
  confirmLoading: boolean = false;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<QuotaionApproveDialog>,
    private quoteService: QuotationService,
    private toastr: ToastrService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.quoteId = this.data?.quoteId;
    this.projectId = this.data?.projectId;
    const isDlp = this.data?.isDLP;
    if (isDlp) {
      this.dlp = isDlp;
    }
  }

  onCancel(): void {
    this.dialogRef.close();
  }


  onApprove(): void {
    if (!this.quoteId) {
      this.toastr.error('No quote ID provided.', 'Error');
      return;
    }
    // this.confirmLoading = true;
      this.quoteService.approveQuote(this.quoteId).subscribe({
        next: (response) => {
            this.toastr.success('Quote approved successfully.');
            this.dialogRef.close(this.quoteId);
            this.generatePDF();
            // this.saveWorkOrder(this.quoteId);
          // this.confirmLoading = true;
        },
        error: (err) => {
          console.error('Error creating project:', err);
          this.toastr.error(err);
          // this.confirmLoading = true;
        },
      });
  }

  generatePDF(): void {
    this.quoteService.generateQuotePDF(this.quoteId).subscribe({
      next: (response) => {
        this.toastr.success('PDF generated successfully.');
      },
      error: (pdfError) => {
        console.error('Error generating PDF:', pdfError);
        this.toastr.error(pdfError.message || 'Failed to generate PDF.');
      },
    });
  }


  
  // saveWorkOrder(id: number): void {
  //   // Call saveWorkOrder with the quoteId
  //   this.quoteService.saveWorkOrder(id).subscribe({
  //     next: (response) => {
  //       this.toastr.success('Work order saved successfully.');
  //       this.dialogRef.close(true);
  //       const createWOrkOrderID = response.data.saveWorkOrder;
  //       this.router.navigate([
  //         `work-order/work-order-edit/${createWOrkOrderID}`,
  //       ]);
  //       this.confirmLoading = true;
  //     },
  //     error: (err) => {
  //       console.error('Error saving work order:', err);
  //       this.toastr.error(err);
  //       this.confirmLoading = true;
  //     },
  //   });
  // }
}
